import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const SPRDH_LOGO = 'https://sprdh.com/wp-content/uploads/2023/08/sprdh-logo-1.png';
const SPRDH_URL = 'https://sprdh.com';

const MemberPortalFooter = () => (
  <Box
    component="footer"
    sx={{
      py: 2,
      px: 2,
      textAlign: 'center',
      borderTop: '1px solid rgba(0, 0, 0, 0.08)',
      backgroundColor: '#fff',
    }}
  >
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        flexWrap: 'wrap',
      }}
    >
      <Typography
        variant="caption"
        component="span"
        sx={{ color: '#000' }}
      >
        Developed by
      </Typography>
      <Link
        href={SPRDH_URL}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          lineHeight: 0,
          color: '#000',
        }}
      >
        <Box
          component="img"
          src={SPRDH_LOGO}
          alt="sprdh"
          sx={{ height: 28, width: 'auto', display: 'block' }}
        />
      </Link>
    </Box>
  </Box>
);

export default MemberPortalFooter;
